import moment from 'moment'
import {
    WALLET_TRANSACTIONS_CONVERSION_ERROR,
    WALLET_TRANSACTIONS_CONVERSION_SUBMIT,
    WALLET_TRANSACTIONS_CONVERSION_SUCCESS,
    WALLET_TRANSACTIONS_DETAIL_ERROR,
    WALLET_TRANSACTIONS_DETAIL_SUCCESS,
    WALLET_TRANSACTIONS_DETAIL_LOAD,
    WALLET_TRANSACTIONS_STATEMENT_ERROR,
    WALLET_TRANSACTIONS_STATEMENT_SUCCESS,
    WALLET_TRANSACTIONS_STATEMENT_LOAD,
    WALLET_TRANSACTIONS_FAVORITES_ERROR,
    WALLET_TRANSACTIONS_FAVORITES_LOAD,
    WALLET_TRANSACTIONS_FAVORITES_SUCCESS,
    WALLET_TRANSACTIONS_RESUME_SUCCESS,
    WALLET_TRANSACTIONS_RESUME_ERROR,
    WALLET_TRANSACTIONS_RESUME_LOAD
} from '../actionTypes'
import { request } from '../../utils/api'
import { getInfoLocalStorage } from '../../utils/api'
import { loginExpired } from './wallet'
import { loadBalance } from './wallet_btc'

export const getConversionBtcBrl = (form, userid, price) => async dispatch => {
    if(moment().isSameOrAfter(getInfoLocalStorage().userExpiration)){
        dispatch(loginExpired())
    } else {
        form.validateFieldsAndScroll(async (err, values) => {
            if(!err){
                try{
                    dispatch(conversionSubmit())
                    const { code, message, id } = await request('wallet/conversion/btc-brl', "POST", {
                        btc: values.btc,
                        price,
                        userid,
                        password: values.password
                    })
                    if(code === 82 || code === 85) {
                        dispatch(conversionSuccess())
                        dispatch(loadBalance(userid)).then(() => window.location.replace(`/wallet/transacao?id=${id}&type=2&status=3`))
                    } else {
                        dispatch(conversionError(message))
                    }
                } catch(e) {
                    dispatch(conversionError())
                }
            }
        })
    }
}

export const getConversionBrlBtc = (form, userid, price) => async dispatch => {
    if(moment().isSameOrAfter(getInfoLocalStorage().userExpiration)){
        dispatch(loginExpired())
    } else {
        form.validateFieldsAndScroll(async (err, values) => {
            if(!err){
                try{
                    dispatch(conversionSubmit())
                    const { code, message, id, status } = await request('wallet/conversion/brl-btc', "POST", {
                        brl: values.brl,
                        price,
                        userid,
                        password: values.password,
                    })
                    if(code === 82 || code === 85) {
                        dispatch(conversionSuccess())
                        dispatch(loadBalance(userid)).then(() => window.location.replace(`/wallet/transacao?id=${id}&type=3&status=3`))
                    } else {
                        dispatch(conversionError(message))
                    }
                } catch(e) {
                    dispatch(conversionError())
                }
            }
        })
    }
}

export const conversionSuccess = (message = 'Conversão realizada com sucesso. Confira seus saldos!') => ({
    type: WALLET_TRANSACTIONS_CONVERSION_SUCCESS,
    payload: {
        message: message
    }
})

export const conversionError = (message = 'Houve um erro ao realizar a conversão. Por favor, verifique seus saldos e entre em contato com um de nossos atendentes.') => ({
    type: WALLET_TRANSACTIONS_CONVERSION_ERROR,
    payload: {
        message: message
    }
})

export const conversionSubmit = () => ({
    type: WALLET_TRANSACTIONS_CONVERSION_SUBMIT
})

export const loadTransactionDetails = (id, type, idWallet) => async dispatch => {
    if(moment().isSameOrAfter(getInfoLocalStorage().userExpiration)){
        dispatch(loginExpired())
    } else {
        try{
            dispatch(detailsLoad())
            const { code, transacao } = await request(`wallet/transaction-details/${id}/${type}`, "POST", {
                idWallet: idWallet
            })
            if(code === 71) {
                dispatch(detailsSuccess(transacao))
            } else {
                dispatch(window.location.replace('/wallet/404'))
                dispatch(detailsError())
            }
        } catch(e) {
            dispatch(detailsError(e))
        }
    }
}

export const detailsSuccess = (details) => ({
    type: WALLET_TRANSACTIONS_DETAIL_SUCCESS,
    payload: {
        details
    }
})

export const detailsError = (message = 'Houve um erro ao carregar os detalhes') => ({
    type: WALLET_TRANSACTIONS_DETAIL_ERROR,
    payload: {
        message
    }
})

export const detailsLoad = () => ({
    type: WALLET_TRANSACTIONS_DETAIL_LOAD
})

export const loadStatement = (id) => async dispatch => {
    if(moment().isSameOrAfter(getInfoLocalStorage().userExpiration)){
        dispatch(loginExpired())
    } else {
        try{
            dispatch(statementLoad())
            const { code, statement } = await request (`wallet/statement/${id}`)
            if(code === 72) {
                dispatch(statementSuccess(statement))
            } else {
                dispatch(statementError())
            }
        } catch(e) {
            dispatch(statementError(e))
        }
    }
}

export const statementSuccess = (statement) => ({
    type: WALLET_TRANSACTIONS_STATEMENT_SUCCESS,
    payload: {
        statement
    }
})

export const statementError = (message = 'Houve um erro ao carregar o histórico') => ({
    type: WALLET_TRANSACTIONS_STATEMENT_ERROR,
    payload: {
        message
    }
})

export const statementLoad = () => ({
    type: WALLET_TRANSACTIONS_STATEMENT_LOAD
})

export const loadFavorites = (id, type) => async dispatch => {
    try{
        dispatch(favoritesLoad())
        const { code, favorites } = await request(`wallet/favorites/${id}/${type}`)
        if(code === 51) {
            dispatch(favoritesSucces(favorites))
        } else {
            dispatch(favoritesError())
        }
    } catch(e) {
        dispatch(favoritesError(e))
    }
}

export const favoritesSucces = (favorites) => ({
    type: WALLET_TRANSACTIONS_FAVORITES_SUCCESS,
    payload: {
        favorites
    }
})

export const favoritesError = (message = 'Houve um erro ao carregar a lista de favoritos') => ({
    type: WALLET_TRANSACTIONS_FAVORITES_ERROR,
    payload: {
        message
    }
})

export const favoritesLoad = () => ({
    type: WALLET_TRANSACTIONS_FAVORITES_LOAD
})

export const loadResume = (id) => async dispatch => {
    try {
        dispatch(resumeLoad())
        const { code, message, result  } = await request(`wallet/clientResume/${id}`)
        if(code === 51){
            dispatch()
        } else {
            dispatch(resumeError())
        }
    } catch (e) {
        dispatch(resumeError())
    }
}
// resumeSuccess
export const resumeSuccess = (resume) => ({
    type: WALLET_TRANSACTIONS_RESUME_SUCCESS,
    payload: {
        resume
    }
}) 
export const resumeError = (message = 'Houve um erro ao carregar o extrato do usuário') => ({
    type: WALLET_TRANSACTIONS_RESUME_ERROR,
    payload: {
        message
    }
})
export const resumeLoad = () => ({
    type: WALLET_TRANSACTIONS_RESUME_LOAD
})